module.exports = __webpack_public_path__ + "static/image/sustainability/pc/ethical@2x.ver2_0_2.jpg?3a19f5dc";